/** @jsx jsx */
import { jsx, Flex } from 'theme-ui'
import '../support-package/table.css'

const UploadTooltip = () => {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        maxWidth: 500,
        color: 'forest',
        lineHeight: '1.2rem',
      }}
    >
      <table className="striped">
        <thead>
          <tr>
            <td colSpan="1">File size and type requirements:</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <h3>Images:</h3>
              <p>
                Files must be less than 8 MB.
                <br />
                Allowed file types: png, gif, jpg, jpeg
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <h3>Video:</h3>
              <p>
                Files must be less than 256 MB.
                <br />
                Allowed file types: mp4, mov, wmv
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <h3>Documents:</h3>
              <p>
                Files must be less than 256 MB.
                <br />
                Allowed file types: txt, doc, docx, xls, xlsx, pdf, ppt, pptx
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <h3>Audio:</h3>
              <p>
                File must be less than 256 MB.
                <br />
                Allowed file types: mp3
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </Flex>
  )
}

export default UploadTooltip
